export default () => ({
    showPhotoModal: false,
    image: {},
    imageLoaded: false,

    openViewPhotoModal(image) {
        this.showPhotoModal = true;
        this.image = image;
        this.imageLoaded = false;

        const img = new Image();

        img.onload = () => {
            this.imageLoaded = true;
        };
        img.src = image.high_res;
    },

    resetPhotoModal() {
        this.showPhotoModal = false;
        this.image = null;
        this.imageLoaded = false;
    },

    handleContextMenu(event) {
        event.preventDefault();
    },
});
